import { useEffect } from "react";
import { useNavigation } from "@react-navigation/native";
import { useTranslation } from "react-i18next";
import { useTheme } from "styled-components/native";
import { DefaultTheme } from "styled-components/native";
import { useUserInfo } from "@redux/slices/userInfoSlice";
import { PriceModes } from "@components/molecules/PriceModeCard/types";
import { isPair } from "@utils/product/productValidators";
import {
  getHeaderStyleBasedOnProduct,
  getPriceModeColorCode,
} from "@components/common/Header/utils";
import { useIsPublicAccessRestricted } from "@utils/usePrivateAppGuard";

interface UsePdpNavigationProps {
  itemDetail: any;
  product_type: string;
  priceMode: number;
}

export const usePdpNavigation = ({
  itemDetail,
  product_type,
  priceMode,
}: UsePdpNavigationProps) => {
  const navigation = useNavigation();
  const { t } = useTranslation();
  const theme = useTheme();
  const userInfo = useUserInfo();
  const { background } = getHeaderStyleBasedOnProduct(product_type);
  const { shouldHide: isRestrictedPublicUser } = useIsPublicAccessRestricted();

  useEffect(() => {
    navigation.setOptions({
      title: `${
        isPair(itemDetail)
          ? t("productDetailPage.title.pair.text", "Pair Details")
          : t("productDetailPage.title.text")
      }`,
      headerStyle: {
        borderBottomColor: !userInfo.userCanSetMarkupInOrangeMode()
          ? theme[getPriceModeColorCode(priceMode)]
          : theme["core-04"],
        borderBottomWidth:
          userInfo.userCanSetMarkupInOrangeMode() ||
          priceMode === PriceModes.WHITE
            ? 1
            : 4,
        backgroundColor: background
          ? theme[background as keyof DefaultTheme]
          : theme["core-03"],
      },
      ...(isRestrictedPublicUser ? { headerLeft: () => null } : {}),
    });
  }, [
    navigation,
    itemDetail?.id,
    t,
    userInfo.userCanSetMarkupInOrangeMode(),
    priceMode,
    background,
    isRestrictedPublicUser,
  ]);
};
